import { Header, Sidebar } from "@/components/layout";
import { APP_CONFIG } from "@/constants/app";
import { LayoutProps } from "@/types/components";
import { cn } from "@/utils/cn";
import React, { useState } from "react";

export const Layout: React.FC<LayoutProps> = ({ children, className = "" }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleMenuToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Verificar se o layout deve ocupar toda a tela (para chat)
  const isFullScreen = className.includes("h-screen");

  return (
    <div className={cn("min-h-screen bg-gray-50 flex flex-col", className)}>
      {/* Header */}
      <Header title={APP_CONFIG.TITLE} onMenuToggle={handleMenuToggle} />

      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        position="left"
      >
        {/* Conteúdo customizado do sidebar pode ser adicionado aqui */}
        <div className="text-sm text-gray-600">
          <p>Versão: {APP_CONFIG.VERSION}</p>
        </div>
      </Sidebar>

      {/* Main Content */}
      <main className={cn("flex-1 pt-20", isFullScreen && "flex flex-col overflow-hidden")}>
        {isFullScreen ? (
          children
        ) : (
          <div className="container mx-auto px-6 py-8">{children}</div>
        )}
      </main>

      {/* Footer - Ocultar em tela cheia */}
      {!isFullScreen && (
        <footer className="bg-white border-t border-gray-200 py-6 mt-auto">
          <div className="container mx-auto px-6">
            <div className="flex items-center justify-between">
              <div className="text-sm text-gray-600">
                © 2025 {APP_CONFIG.TITLE}. Todos os direitos reservados.
              </div>
              <div className="flex items-center space-x-4 text-sm text-gray-600">
                <span>v{APP_CONFIG.VERSION}</span>
              </div>
            </div>
          </div>
        </footer>
      )}
    </div>
  );
};
